import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { LoginService } from '../components/login/login.service';
import { AuthService } from '@auth0/auth0-angular';
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class MyPermissionService {
  allowedUrls: string[] = [];
  userPrefPermissions: string[] = [];

  constructor(private http: HttpClient, private loginService: LoginService, private auth: AuthService) {
    
  }

  loadPermissions(): Promise<void> {
    const token = localStorage.getItem('bearerToken');
    if (!token) {
      return Promise.resolve();
    }

    return this.loginService.loggedUserData().toPromise()
    .then(data => {
      localStorage.setItem('loginId', data.id);
      localStorage.setItem('type', data.type);
      localStorage.setItem('role', data.role);
      localStorage.setItem('defaultLandingPage', data.defaultLandingPage);
      (window as any).loggedInUser = data;

      this.allowedUrls = data.permissions || [];
      this.userPrefPermissions =  data.preferences || [];
    })
    .catch(() => {
      localStorage.clear();
      this.auth.logout({ logoutParams: { returnTo: document.location.origin }} as any);
      return Promise.resolve();
    });

  }

  isUrlAllowed(url: string, userPref?: string): boolean {
    const normalize = (u: string) =>
      u.replace(/^\/|\/$/g, '').toLowerCase();

    const cleanUrl = normalize(url);

    const urlAllowed = this.allowedUrls
      .map(normalize)
      .includes(cleanUrl);

    const prefAllowed = userPref
      ? this.userPrefPermissions.includes(userPref)
      : false;

    return urlAllowed || prefAllowed;
  }

}
